import { useIsInternalAccount } from "MVVM/Hooks/useIsInternalAccount";
import { tiktokScopes } from "MVVM/Utilities/Auth/tiktokScopes";
import axios from "axios";
import React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box } from "rebass";
import { FormLink } from "../../Components/Button";
import { Body } from "../../Components/Text";
import {
  FloatingContainer,
  FullScreenWrapper,
} from "../../Components/Wrappers";
import { FloatingContent } from "../../Components/Wrappers/Existing/floatingContent";
import { useUser } from "../../Hooks/useUser";
import { getQueryParam } from "../../Utilities/QueryParam";
import { useHistory } from "react-router-dom";
import Loading from "../../../animations/loading.json";
import Lottie from "lottie-react";
import { useLazyQuery } from "@apollo/client";
import { RIOT_RSO_LINK } from "../../GraphQL/riotRSO";
import { useSetRecoilState } from "recoil";
import { AllstarOauthState } from "../../State/oauth";

import {
  generateCodeChallenge,
  generateCodeVerifier,
  generateBNetOAuthState,
} from "../../Utilities/Auth";

const {
  REACT_APP_FACEIT_OAUTH,
  REACT_APP_EPIC_REDIRECT_URI,
  REACT_APP_EPIC_CLIENT_ID,
  REACT_APP_BATTLENET_CLIENT_ID,
} = process.env;

const lottieStyle = {
  height: 36,
};

type TAuthenticateParams = {
  route:
    | "steam"
    | "discord"
    | "tiktok"
    | "google"
    | "riot"
    | "mobile"
    | "faceit"
    | "battlenet";
};

async function openDesktopApplication(
  setDesktopAppButton: React.Dispatch<React.SetStateAction<boolean>>,
  token: string,
) {
  const popup_window = window.open(`allstargg://token=${token}`);
  try {
    popup_window?.focus();
  } catch (e) {
    alert(
      "Pop-up Blocker is enabled, please add this site to your exception list to launch the Allstar Desktop App!",
    );
    setDesktopAppButton(true);
  }
}

function googleRedirect() {
  const {
    REACT_APP_GOOGLE_CLIENT_ID: client_id,
    REACT_APP_GOOGLE_REDIRECT_URI: redirect_uri,
  } = process.env;

  if (!redirect_uri || !client_id) {
    throw new Error(
      "Missing REACT_APP_GOOGLE_CLIENT_ID or REACT_APP_GOOGLE_REDIRECT_URI",
    );
  }

  const scope = [
    "https://www.googleapis.com/auth/userinfo.profile",
    "https://www.googleapis.com/auth/userinfo.email",
    "https://www.googleapis.com/auth/youtube.upload",
  ].join(" ");

  const csrfArray = new Uint8Array(32);
  window.crypto.getRandomValues(csrfArray);

  const state = Array.from(csrfArray, (byte) =>
    byte.toString(16).padStart(2, "0"),
  ).join("");
  localStorage.setItem("googleCSRF", state);

  const params = new URLSearchParams({
    client_id,
    redirect_uri,
    response_type: "code",
    scope,
    access_type: "offline",
    include_granted_scopes: "true",
    prompt: "consent",
    state,
  });

  window.location.replace(
    `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`,
  );
}

export default function Authenticate() {
  const history = useHistory();
  const [, setDesktopAppButton] = useState(false);
  const [, setDesktopLink] = useState("");
  const { allstarUser, getFreshProfile } = useUser();
  const { route } = useParams<TAuthenticateParams>();
  const setAllstarOauthState = useSetRecoilState(AllstarOauthState);
  const [getRiotRSOLink] = useLazyQuery(RIOT_RSO_LINK, {
    fetchPolicy: "cache-and-network",
  });
  const referrer = getQueryParam("referrer");
  const flow = getQueryParam("flow");
  const creatorFlow =
    route === "tiktok" && referrer === "CREATOR_DASHBOARD" && flow === "link";
  const isInternalAccount = useIsInternalAccount();
  const next = getQueryParam("next");
  if (next) localStorage.setItem("next", next);
  const displayLoadingSpinner = route === "mobile";
  const encodedBaseURL = encodeURIComponent(
    process.env.REACT_APP_BASE_URL as string,
  );
  const encodedEpicRedirect = encodeURIComponent(
    REACT_APP_EPIC_REDIRECT_URI || "",
  );
  const [URLS] = useState<any>({
    steam: process.env.REACT_APP_STEAM_OPEN_ID as string,
    discord: `https://discord.com/api/oauth2/authorize?client_id=${process.env.REACT_APP_DISCORD_OAUTH}&redirect_uri=${encodedBaseURL}%2Foauth%2Fdiscord&response_type=code&scope=identify%20email%20guilds`,
    epic: `https://www.epicgames.com/id/authorize?client_id=${REACT_APP_EPIC_CLIENT_ID}&redirect_uri=${encodedEpicRedirect}&response_type=code&scope=basic_profile`,
  });

  useEffect(() => {
    if (creatorFlow && !isInternalAccount) {
      history.replace("/library");
      return;
    }
    if (allstarUser.loggedIn) {
      // is desktop app...
      if (referrer === "desktop_app") {
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/items/desktoptoken/@me?token=${allstarUser.token}`,
          )
          .then(({ data }) => {
            const token = data.token;
            setDesktopLink(`allstargg://token=${token}`);
            openDesktopApplication(setDesktopAppButton, token);
            history.push("/clips");
          });

        return;
      }

      if (referrer === "mobile_app") {
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/items/desktoptoken/@me?token=${allstarUser.token}`,
          )
          .then(({ data }) => {
            const token = data.token;
            window.JSBridge?.showMessageInNative(token);
            history.push("/clips");
          });

        return;
      }
    }

    const path = URLS[route];
    const now = new Date();
    now.setMinutes(now.getMinutes() + 5);
    const FiveMinutes = new Date(now);
    const AuthDataObject = {
      expiry: FiveMinutes,
      referrer,
      route,
      path,
      flow,
      randomBlob: "",
    };

    if (path) {
      // confirm we have a URL
      setAllstarOauthState(AuthDataObject);

      window.location.replace(AuthDataObject.path);
    } else if (route === "battlenet") {
      AuthDataObject.randomBlob = generateBNetOAuthState();
      AuthDataObject.path = `https://oauth.battle.net/authorize?response_type=code&scope=openid&state=${AuthDataObject.randomBlob}&redirect_uri=${encodedBaseURL}%2Foauth%2Fbattlenet&client_id=${REACT_APP_BATTLENET_CLIENT_ID}`;

      setAllstarOauthState(AuthDataObject);

      window.location.replace(AuthDataObject.path);
    } else if (route === "tiktok") {
      if (!process.env.REACT_APP_BASE_URL)
        return console.error("REACT_APP_BASE_URL not set");

      const baseUrlEncoded = encodeURIComponent(process.env.REACT_APP_BASE_URL);
      const tiktokURL = `https://www.tiktok.com/v2/auth/authorize?client_key=awo8h6fk5xb1mfgd&scope=${tiktokScopes(
        creatorFlow && isInternalAccount,
      )}&redirect_uri=${baseUrlEncoded}%2Foauth%2Ftiktok&response_type=code`;

      setAllstarOauthState(AuthDataObject);
      window.location.replace(tiktokURL);
    } else if (route === "faceit") {
      const codeVerifier = generateCodeVerifier();
      localStorage.setItem("codeVerifier", codeVerifier);
      setAllstarOauthState(AuthDataObject);
      generateCodeChallenge(codeVerifier).then((challenge) => {
        const faceitURL = `${REACT_APP_FACEIT_OAUTH}&code_challenge=${challenge}&code_challenge_method=S256`;
        window.location.replace(faceitURL);
      });
    } else if (route === "google") {
      setAllstarOauthState(AuthDataObject);
      googleRedirect();
    } else if (route === "riot") {
      getRiotRSOLink().then(({ data }) => {
        AuthDataObject.path = data.riotRsoLink;

        setAllstarOauthState(AuthDataObject);
        window.location.replace(data.riotRsoLink);
      });
    } else if (route === "mobile") {
      const token = getQueryParam("token") || localStorage.getItem("token");
      const next = getQueryParam("next");

      if (token) {
        localStorage.setItem("token", token);
        getFreshProfile().then(() => {
          if (next) {
            setTimeout(() => {
              history.push(next);
            }, 1500);
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route, creatorFlow, isInternalAccount]);

  return (
    <FullScreenWrapper>
      {displayLoadingSpinner ? (
        <>
          {allstarUser?.loggedIn ? (
            <></>
          ) : (
            <Lottie style={lottieStyle} animationData={Loading} loop={true} />
          )}
        </>
      ) : (
        <>
          {" "}
          <FloatingContainer>
            <FloatingContent
              title="Logging into Allstar"
              body={
                <Body>
                  This will take just a moment. You will be redirected back to
                  the app momentarily, have fun creating amazing content!
                </Body>
              }
            >
              <Box>
                <FormLink to={"/support"}>
                  Having trouble? Contact support.
                </FormLink>
              </Box>
            </FloatingContent>
          </FloatingContainer>
        </>
      )}
    </FullScreenWrapper>
  );
}
